var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.computedStyle)},[_c('div',{staticStyle:{"margin":"auto","width":"98%","padding-right":"5px","padding-left":"5px","padding-top":"24px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }